export default {
  title: 'Wir haben geschlossen',
  subtitle: 'Kurze Pause!',
  description: 'Während unsere Türen geschlossen sind, können Sie Ihre nächste Bestellung jetzt ganz einfach planen.',
  buttons: {
    schedule_order: 'Bestellung planen',
    close: 'Schließen',
  },
  errors: {
    scheduled_for: 'Geben Sie Datum und Uhrzeit an',
  },
};
